import React from "react";
import Layout from "../../Layout";
import TelephonyLeftNav from "../../Layout/TelephonyLeftNav";

export default function DialerPage() {
  return (
    <Layout leftNav={<TelephonyLeftNav />} className="pt-0 pb-0">
      <iframe
        src={`${process.env.REACT_APP_DIALER_BASE_URL}`}
        width="100%"
        height="850px"
        frameBorder="0"
        allow="microphone; camera; autoplay; encrypted-media"
        style={{
          border: "none",
          // borderRadius: "8px",
          background: "transparent",
        }}
      />
    </Layout>
  );
} 